import { render, staticRenderFns } from "./tabs-Attachment.vue?vue&type=template&id=11821478&scoped=true&"
import script from "./tabs-Attachment.vue?vue&type=script&lang=js&"
export * from "./tabs-Attachment.vue?vue&type=script&lang=js&"
import style0 from "./tabs-Attachment.vue?vue&type=style&index=0&id=11821478&scoped=true&lang=less&"
import style1 from "./tabs-Attachment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11821478",
  null
  
)

export default component.exports